// src/data/filingFieldRegistry.js
// SEC-FILINGS-PAGE — new file.
//
// Display metadata ONLY — category grouping/order/labels itself lives in
// backend/services/filingsQueryService.js (derived from edgarFormConfig.js,
// the real source of truth). This file adds icon/color/accent styling on
// top of category keys the backend already returns — never re-derives the
// grouping logic, so the two can never drift on WHICH categories exist,
// only on how they look.
//
// Keys here MUST match CATEGORY_LABELS keys in filingsQueryService.js.

export const CATEGORY_STYLE = {
  DISTRESS:       { icon: '⚠️', color: '#ff4444' },
  ACTIVIST:       { icon: '🎯', color: '#ffaa00' },
  GOVERNANCE:     { icon: '🏛️', color: '#a78bfa' },
  MATERIAL_EVENT: { icon: '📌', color: '#00d4ff' },
  ANNUAL:         { icon: '📗', color: '#00ff88' },
  QUARTERLY:      { icon: '📘', color: '#00ff88' },
  INSIDER:        { icon: '👤', color: '#00d4ff' },
  CAPITAL:        { icon: '💰', color: '#94a3b8' },
  FOREIGN:        { icon: '🌐', color: '#94a3b8' },
};
export const DEFAULT_CATEGORY_STYLE = { icon: '📄', color: '#64748b' };

// Two independent gates — see filingsQueryService.js header for why they
// are not one flag. Copy differs deliberately: SIGN_IN_REQUIRED is
// actionable (sign in unlocks it now); INNER_CIRCLE_UNAVAILABLE is NOT
// actionable via sign-in — Product 3 doesn't exist yet, and it would be
// dishonest to imply signing in helps. Do not change INNER_CIRCLE_UNAVAILABLE's
// copy to a "Sign In" CTA until Product 3 actually ships.
export const LOCK_COPY = {
  SIGN_IN_REQUIRED: {
    title: 'Members Only',
    body:  'Sign in to view this filing.',
    ctaLabel: 'Sign In',
    actionable: true,
  },
  INNER_CIRCLE_UNAVAILABLE: {
    title: 'Inner Circle — Coming Soon',
    body:  'This tier isn\u2019t available yet.',
    ctaLabel: null,
    actionable: false,
  },
};

// Capability gate copy (form-type filter, direct form search, significance
// sort, high-conviction preset) — member-only capabilities, enforced
// server-side in filingsQueryService.js. This copy is UI-only affordance
// text; never trust the client to actually apply these unauthenticated.
export const CAPABILITY_GATE_TOOLTIP = 'Sign in to unlock this filter';

// Significance (1-10) → visual weight. Keeps the "high-conviction" framing
// consistent everywhere significance is shown (feed rows, category cards).
export function significanceWeight(score) {
  const n = Math.max(0, Math.min(10, Number(score) || 0));
  return {
    filled: n,
    empty: 10 - n,
    isHighConviction: n >= 8,
  };
}

export function categoryStyle(category) {
  return CATEGORY_STYLE[category] || DEFAULT_CATEGORY_STYLE;
}
